import { Component, OnInit } from '@angular/core';
import { WhatNewService } from 'src/shared/services/whatnew.service';

@Component({
    selector: 'app-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
})
export class NotificationComponent implements OnInit {

    
    documents: any[] = [];
    selectedDocument: any = null;
    selectedItemId: number | null = null;

    constructor(private whatNewService: WhatNewService) {}

    ngOnInit(): void {
        this.getListWhatNew();
    }

    getListWhatNew() {
        this.whatNewService.getListWhatNew().subscribe((data: any) => {
            this.documents = data.data
            this.getDetailWhatNew(this.documents[0].id)
        });
    }

    getDetailWhatNew(id: string) {
        this.whatNewService.getDetailWhatNew(id).subscribe((data: any) => {
            this.selectedDocument = data.data;
            this.selectedItemId = +id;
        });
        
    }
}
